
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './MenelCaptcha.module.css';

const API_URL = `${process.env.REACT_APP_API_URL}/captcha/generate`;

const MenelCaptcha = ({ onVerify }) => {
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const fetchCaptcha = async () => {
    setLoading(true);
    setErrMsg('');
    try {
      const res = await axios.get(API_URL, { timeout: 8000 });
      const { svg, token } = res.data || {};
      if (!svg || !token) throw new Error('Invalid captcha payload');

      setCaptchaSvg(svg);
      setCaptchaToken(token);
      setInput('');
      onVerify && onVerify(token, '');
    } catch (err) {
      console.error('Error loading captcha:', err);
      setCaptchaSvg('');
      setCaptchaToken('');
      setInput('');
      setErrMsg('Unable to load captcha. Click refresh.');
      onVerify && onVerify('', '');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCaptcha(); }, []);

  const handleChange = (e) => {
    const v = e.target.value;
    setInput(v);
    onVerify && onVerify(captchaToken, v);
  };

  const dataUrl = captchaSvg ? `data:image/svg+xml;utf8,${encodeURIComponent(captchaSvg)}` : '';

  return (
    <div className={styles.wrap}>
      <div className={styles.imageBox} aria-live="polite" aria-busy={loading}>
        {loading ? (
          <div className={styles.spinner} />
        ) : dataUrl ? (
          <img src={dataUrl} alt="Captcha" className={styles.img} />
        ) : (
          <div style={{ color: '#c9d2dc', fontSize: '.9rem' }}>
            {errMsg || 'Unable to load captcha'}
          </div>
        )}
      </div>

      <input
        className={styles.input}
        type="text"
        value={input}
        onChange={handleChange}
        placeholder="Type the letters"
        autoComplete="off"
        spellCheck="false"
        maxLength={12}
        aria-label="Captcha input"
      />

      <button
        type="button"
        className={styles.refresh}
        onClick={fetchCaptcha}
        disabled={loading}
        aria-label="Refresh captcha"
        title="Refresh captcha"
      >
        {loading ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
};

export default MenelCaptcha;


